import { BaseModel } from 'paliari-js-utils'
import { required, minLength } from 'vuelidate/lib/validators'

export const attributes = () => ({
  id: null,
  titulo: '',
  descricao: '',
})

export default class AssuntoInformacao extends BaseModel {
  constructor(obj) {
    super(attributes(), obj)
  }

  static get validations() {
    return {
      titulo: { required, minLength: minLength(5) },
      descricao: { required, minLength: minLength(5) },
    }
  }
}
